// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"79":"254983ad7704cd24","239":"d0c8d22d2da6c273","553":"f5c359d3df2a0015","863":"739d4f6adbc323ac"}[chunkId] + ".js";
};